import { render, staticRenderFns } from "./BankDetail.vue?vue&type=template&id=3f13e44e&scoped=true"
import script from "./BankDetail.vue?vue&type=script&lang=js"
export * from "./BankDetail.vue?vue&type=script&lang=js"
import style0 from "./BankDetail.vue?vue&type=style&index=0&id=3f13e44e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f13e44e",
  null
  
)

export default component.exports